import {FormFieldRegistration} from "./field-registration";
import {Form} from "./form";
import {BaseForm} from "./base-form";

export class FormField {
  public id: string;
  public form: Form;
  public applicantForm: BaseForm;
  public label: string;
  public fieldName: string;
  public formTitle: string;
  public expanded: boolean;
  public fieldKey: string;
  public jsonDeterminants: string;
  public fields: any[];
  public items: any[];
  public parentComponent: string;
  public type: string;
  public remoteType: string;
  public registrations: FormFieldRegistration[];
  public inputHidden: boolean;
  public outputHidden: boolean;
  public isgroup: boolean;
  public dataSrc: string = null;
  public disabled: boolean;
  public lead: boolean;
  public level: number;
  public orderNumber: number;
  public copyValueFrom: any;
  public filter: string; // some fields are only for input or output
}
